/**
 * This is the entry point for all scripts. 
 * Write or import yours in this file.
 */

// helpers 
import './helpers/index.js';

// components
import "./components/menu.js";
import "./components/accordion.js";

const backgroundImage = document.querySelector('.background--image');    
if (backgroundImage) {
    // fade in background image on page load
    backgroundImage.style.opacity = 1;
}